import { inject } from '@angular/core';
import { AuthService } from './services/auth.service';

export const initialize = () => {
	const authService = inject(AuthService);
	return () => authService.init();
};
